import React from 'react';
import { useTranslation } from 'react-i18next';
import VerifiedShieldIcon from './VerifiedShieldIcon';
import './VerifiedChip.scss';

interface Props {
  /** Picks the label: "Verified seller" vs "Verified buyer". */
  type: 'seller' | 'buyer';
}

/**
 * "Verified seller" / "Verified buyer" trust chip for listing cards (JAA-305).
 * Sits as the first item in the property chip row (or standalone on the small
 * card), styled to match sibling chips with a teal tint + shield glyph.
 * "Verified" = the listing's creator is identity-verified (Stripe Identity).
 */
const VerifiedChip: React.FC<Props> = ({ type }) => {
  const { t } = useTranslation();
  const label = t(type === 'buyer' ? 'verification.verifiedBuyer' : 'verification.verifiedSeller');
  return (
    <span className="verified-chip">
      <VerifiedShieldIcon px={15} className="verified-chip__icon" />
      {label}
    </span>
  );
};

export default VerifiedChip;
